import { MappedIconMicro } from "@/icons/icon-mapping-micro";
import { Context } from "@/types/preview";

type ContextConfiguration = {
  icon: MappedIconMicro;
  title: string;
};

export const CONTEXT_TO_CONFIGURATION: Record<Context, ContextConfiguration> = {
  email: {
    icon: "envelope",
    title: "Email",
  },
  web: {
    icon: "globe-alt",
    title: "Web",
  },
  email_free: {
    icon: "currency-dollar",
    title: "Email (free)",
  },
  web_free: {
    icon: "currency-dollar",
    title: "Web (free)",
  },
};
